import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStatechangePasswordUser = {
  changePasswordUser: { data: null, loading: false, error: null },
};

export const changePasswordUser = createAsyncThunk('user/changePasswordUser', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(`${process.env.REACT_APP_SERVER_API}/auth/password`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerchangePasswordUser = {
  [changePasswordUser.pending]: (state) => {
    state.changePasswordUser.loading = true;
    state.changePasswordUser.error = null;
  },
  [changePasswordUser.fulfilled]: (state, action) => {
    state.changePasswordUser.loading = false;
    state.changePasswordUser.data = true;
    state.changePasswordUser.error = null;
  },
  [changePasswordUser.rejected]: (state, action) => {
    state.changePasswordUser.loading = false;
    state.changePasswordUser.error = action.payload;
  },
};
